









































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal/modal-config.model";
import { ref, computed, onMounted, reactive } from "@vue/composition-api";
import AppCheckbox from "@/components/AppCheckbox.vue";
import { state } from "@/views/investigation/data/state";
import { SharedState } from "@/common/state";
import { state as newInvState } from "@/views/entity-investigation/data/state";
import { AppAnalytics } from "@/analytics";
import { Subject } from "./data/model";
export default Vue.extend({
  components: {
    Modal,
    AppCheckbox,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const { isDemo } = SharedState;
    const { createInvestigation, updateInvestigation, investigations } = state;
    const { current_subject } = newInvState;

    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "30rem",
      height: "auto",
      backdropDismiss: true,
    };

    const theModalData = reactive({
      item: null as Subject | null,
      mode: "save" as "save" | "edit",
    });

    const isPrivate = ref(true);

    const name = ref("");

    const close = () => {
      emit("cancel");
    };

    const suggestedName = computed(() => {
      if (theModalData.mode === "save") {
        return (
          current_subject.value.name +
          (current_subject.value.type === "LABEL" ? " Information type" : "")
        );
      } else {
        return current_subject.value.name;
      }
    });

    onMounted(() => {
      name.value = suggestedName.value;
      if (props.modalData) {
        // @ts-ignore
        theModalData.item = props.modalData.item;
        // @ts-ignore
        theModalData.mode = props.modalData.mode;
        // @ts-ignore
        if (props.modalData.mode === "edit") {
          name.value = current_subject.value.name;
          isPrivate.value = investigations.value.find(
            (inv) => inv.objectId === current_subject.value.id
          )!.shared;
        } else {
          isPrivate.value = true;
        }
      }
    });

    const save = async () => {
      AppAnalytics.report({
        component: "Investigation",
        eventName: `Watchlist[Action:Save]`,
      });

      if (theModalData.mode === "save") {
        const item = {
          ...current_subject.value,
          shared: !isPrivate.value,
        };
        const { id: objectId, ...rest } = item;
        await createInvestigation({ ...rest, objectId });
      } else {
        const inv = investigations.value.find(
          (inv) => inv.objectId === current_subject.value.id
        )!;
        await updateInvestigation({
          id: current_subject.value.id,
          name: inv.name,
          shared: !isPrivate.value,
        });
      }
      emit("submit");
    };

    const disableSave = computed(() => name.value.trim().length < 1);

    return {
      theModalData,
      config,
      isPrivate,
      name,
      close,
      save,
      disableSave,
      isDemo,
    };
  },
});
